import React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '@/shared/lib/classnames/cn';
import type { VariantProps } from 'class-variance-authority';
const discountVariants = cva('rounded-full px-2 py-1 text-xs text-white', {
  variants: {
    position: {
      none: '',
      absolute: 'absolute z-10'
    },
    color: {
      default: 'bg-statusSuccess',
      gradient: 'bg-gradient-to-r from-[#6ACB2E] via-[#8CD128] to-[#B6D726]'
    }
  },
  defaultVariants: {
    position: 'none',
    color: 'default'
  }
});
type DiscountVariantsProps = VariantProps<typeof discountVariants>;
interface Props extends DiscountVariantsProps {
  children: React.ReactNode;
  className?: string;
}
export const Discount: React.FC<Props> = ({
  children,
  color,
  className = '',
  position
}) => {
  return <span className={cn(discountVariants({
    position,
    color
  }), className)} data-sentry-component="Discount" data-sentry-source-file="Discount.tsx">{children}</span>;
};